'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


/**
 * This allows components to connect to the "elementConnections store" so they can query the store and
 * place data onto the component's props.
 *
 * It's a decorator that accepts mapConnectionStateToProps (an object that defines the data to retrieve from the state
 * and the props to assign it to).
 */
exports.default = function (mapConnectionStateToProps) {
    return function (DecoratedComponent) {
        var ElementConnectionObserver = function (_React$Component) {
            _inherits(ElementConnectionObserver, _React$Component);

            function ElementConnectionObserver(props, context) {
                _classCallCheck(this, ElementConnectionObserver);

                var _this = _possibleConstructorReturn(this, (ElementConnectionObserver.__proto__ || Object.getPrototypeOf(ElementConnectionObserver)).call(this, props, context));

                _this.getCurrentState = function () {
                    return mapConnectionStateToProps(_this.manager.store.getState(), _this.props);
                };

                _this.handleChange = function () {
                    var currentState = _this.getCurrentState();

                    if ((0, _recompose.shallowEqual)(currentState, _this.state)) return;

                    _this.setState(currentState);
                };

                _this.manager = context.elementConnectionsManager;

                _this.unsubscribe = _this.manager.subscribeToStateChange(_this.handleChange);

                _this.state = _this.getCurrentState();
                return _this;
            }

            _createClass(ElementConnectionObserver, [{
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    // Stop listening to state changes
                    this.unsubscribe();
                }

                // TODO Need to check # of arguments like React-redux to determine whether to invoke or not


                // TODO Will likely need some significant performance improvements here

            }, {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(DecoratedComponent, _extends({}, this.state, this.props));
                }
            }]);

            return ElementConnectionObserver;
        }(_react2.default.Component);

        ElementConnectionObserver.contextTypes = {
            elementConnectionsManager: _propTypes2.default.object.isRequired
        };

        return ElementConnectionObserver;
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/connections/components/elementConnectionsObserverDecorator.js
// module id = 1706
// module chunks = 0